module.exports = require("././dist/textAngular.js");
module.exports = require("././dist/textAngular-sanitize.js");
module.exports = require("././dist/textAngularSetup.js");
require("././dist/textAngular.css");


//////////////////
// WEBPACK FOOTER
// textAngular (bower component)
// module id = 507
// module chunks = 0